/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import styled from "styled-components";
import { useEffect } from "react";
import { getAvatarUrl } from "../../libs/index";
import { Link } from "react-router-dom";
import { formatNumber } from "../Pages/Contestant/ContestantDetail";
// {`/images/contestant/avatar/${configId}.jpg`}
export const ItemRank = ({
  stars,
  name,
  rank,
  image,
  miss,
  table,
  className,
  ...props
}) => {
  let configId = miss?.code;

  return (
    <Styles id={`rank-${rank}`}>
      <Link to={`/thi-sinh/${table}/${miss?._id}`}>
        <div className="module">
          <div className="content">
            <div
              className={`rank-item__box ${
                rank === 2 ? "top-2" : rank === 3 ? "top-3" : ""
              }`}
            >
              <div className={`image ${rank === 1 ? "top-1" : ""}`}>
                <img
                  className={`avatar ${rank === 1 ? "top-1" : ""}`}
                  src={getAvatarUrl(configId)}
                />
                {/* {rank !== 1 ? (
                  <div className="rating-number">
                    <p>#{rank}</p>
                    <img
                      src="/images/icon_rating.png"
                      alt=""
                      className="icon"
                    />
                  </div>
                ) : (
                  ""
                )} */}
                {/* <img className='avatar' src={`/images/contestant/avatar/${configId}.jpg`}/> */}
                {/* <img src="/images/a1.png" className={`avatar ${rank === 1 ? "top-1" : ""}`}/> */}
              </div>
              <p className="text">{miss?.fullname}</p>
              <div className="item-vote">
                {/* <p className="scores">Điểm bình chọn:</p> */}
                <span className="number">
                  {formatNumber(miss?.totalStar)}{" "}
                  <span style={{ fontSize: "18px" }}>⭐️</span>
                </span>
              </div>
              <div className="item-star">
                <div className="star">
                  <p className="star-avatar">Bvote</p>
                  <p className="star-number">
                    {formatNumber(miss?.totalPoint)}{" "}
                    <img src="/images/star.svg" alt="" />
                  </p>
                </div>

                <div className="star">
                  <p className="star-avatar">AvatarArt:</p>
                  <p className="star-number">
                    {formatNumber(miss?.totalStarAA)}{" "}
                    <img src="/images/star.svg" alt="" />
                  </p>
                </div>
              </div>
              <button className="btn">Bình chọn</button>
            </div>
          </div>
          <div className="item-rating">
            <img
              src={`/images/${
                rank === 1
                  ? "img_rating2.png"
                  : rank === 2
                  ? "img_rating1.png"
                  : "img_rating3.png"
              }`}
              alt=""
            />
          </div>
        </div>
      </Link>
    </Styles>
  );
};

const Styles = styled.div`
  :hover {
    .rank-item__box {
      box-shadow: 3px 3px 20px #a15bff55, -3px -3px 20px #a15bff55;
      img {
        transform: scale(1.03);
      }
    }
  }
  &#rank-1 {
    margin-top: -145px;
  }
  .content {
    background: #212635;
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    position: relative;
    z-index: 1;
    .rank-item__box {
      position: relative;
      padding: 12px;
      /* margin:0 60px; */

      display: block;
      /* flex-direction: column; */
      align-items: center;
      &.1 {
      }
      &.top-2 {
        /* margin-top: 280px !important; */
      }
      &.top-3 {
        /* margin-top: 300px !important; */
      }

      .image {
        position: relative;
        border-radius: 12px;
        overflow: hidden;
        .rating-number {
          position: absolute;
          top: -11px;
          left: -6px;
          width: 38px;
          height: 34px;
          background: linear-gradient(135deg, #3ff89f 0%, #0384fc 100%);
          border-radius: 4px 4px 4px 0px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          p {
            margin: 0;
          }
          .icon {
            position: absolute;
            bottom: -7px;
            left: 0;
          }
        }

        &.top-1 {
          /* max-width: 344px; */
          .avatar {
            min-height: 344px;
          }
        }
        span {
          position: absolute;
          width: 100%;
          height: 100%;
          /* top:0;
                left:50%; */

          img {
            &.king {
              /* width:100%; */
              position: absolute;
              transform: translate(-50%, -70px);
              top: 0%;
              left: 50%;
            }
          }
          .rank-top {
            position: absolute;
            width: 69px;
            height: 67px;
            right: 28px;
            bottom: 0%;
            display: flex;
            align-item: center;
            justify-content: center;
            p {
              margin: 0;
              font-size: 20px;
              color: white;
              position: absolute;
              text-align: center;
              top: 50%;
              transform: translateY(-50%);
              font-size: 32px;
              line-height: 48px;
              font-weight: 700;
            }
          }
          .rest-rank-top {
            position: absolute;
            bottom: 12px;
            right: 12px;
            width: 42px;
            height: 42px;
            border-radius: 50%;
            padding: 3px;
            background: white;
            p {
              background: #cb8b28;
              color: white;
              font-family: Be Vietnam Pro;
              font-size: 20px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0;
              width: 100%;
              height: 100%;
            }
          }
        }
        .avatar {
          width: 100%;
          border-radius: 12px;
          height: 246px;
          transition: 0.3s;

          /* width:244px; */
          /* border: 1px solid #cb8b28; */
          /* &.top-1 {
          border: 8px solid #cb8b28;
          padding: 0;
        } */
        }

        /* &:hover {
        background: rgba(0, 0, 0, 0.05);
        box-shadow: -4px 4px 20px #cb8b28;
        transform: scale(1.015) translate(5px, -5px);
        border: 1px solid white;
        border-radius: 50%;
        &::before {
          top: 8px;
          left: -8px;
        }
      } */
      }
      /* .stars {
      justify-content: center;
      color: white;
      display: flex;
      align-items: center;
      p {
        margin: 0;
        color: #1f2839;
        font-weight: 700;
        font-size: 36px;
        font-family: Be Vietnam Pro_Bold;
      }
      img {
        padding-bottom: 8px;
        margin-left: 4px;
      }
    }
    .name {
      font-size: 28px;
      font-weght: 400;
      letter-spacing: 3px;
      text-align: center;
      font-family: Wylie;
    } */
      .text {
        padding-top: 15px;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
        color: #ffffff;
        margin-bottom: 0px;
        text-transform: uppercase;
        white-space: nowrap;
      }
      .item-vote {
        display: flex;
        align-items: center;
        justify-content: center;
        .scores {
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 0px;
        }
        .number {
          padding-left: 4px;
          font-weight: 700;
          font-size: 20px;
          margin-top: 8px;
          background: linear-gradient(
            89.83deg,
            #c49664 0.16%,
            #feefa9 50.01%,
            #c89a66 99.86%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
          margin-bottom: 0px;
        }
      }
      .item-star {
        padding-top: 8px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: space-between;
        gap: 0 8px;
        .star {
          background: #2a3045;
          border-radius: 4px;
          padding: 4px;
        }
        .star-avatar {
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          color: #ffffff;
          margin: 0;
        }
        .star-number {
          text-align: center;
          padding-left: 4px;
          display: flex;
          font-weight: 700;
          align-items: center;
          justify-content: center;
          margin: 0;
          background: linear-gradient(
            89.83deg,
            #c49664 0.16%,
            #feefa9 50.01%,
            #c89a66 99.86%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
          font-size: 16px;
          img {
            padding-left: 4px;
          }
        }
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        background: #2a3045;
        border: 1px solid rgba(255, 255, 255, 0.05);
        border-radius: 12px;
        font-weight: 600;
        font-size: 16px;
        color: #a5bfd7;
        :hover {
          background: linear-gradient(94.08deg, #a15bff 0%, #ff8a5a 100%);
          color: white;
          border: unset;
        }
      }
      @media only screen and (max-width: 991px) {
        .image {
          &.top-1 {
            .avatar {
              min-height: 300px;
            }
          }
        }
        .text {
          font-size: 16px;
        }
        .item-vote {
          .scores {
            font-size: 14px;
          }
          .number {
            font-size: 18px;
          }
        }
        .item-star {
          padding: 8px 10px;
          display: block;
          text-align: center;
          .star {
            /* display: inline; */
            margin-bottom: 20px;
            .star-avatar {
              font-size: 14px;
            }
            .star-number {
              font-size: 20px;
            }
          }
        }
        .btn {
          margin: 15px auto;
        }
      }
      @media only screen and (max-width: 767px) {
        .text {
          font-size: 16px;
        }
        .item-vote {
          .scores {
            font-size: 17px;
          }
          .number {
            font-size: 23px;
          }
        }
        .item-star {
          .avatar {
            font-size: 17px;
          }
          .number {
            font-size: 23px;
          }
        }
        .btn {
          margin: 15px auto;
        }
        .image {
          .avatar {
            height: 100%;
          }
          &.top-1 {
            .avatar {
              min-height: 100%;
            }
          }
        }
      }
      @media only screen and (max-width: 576px) {
        /* &.top-2 {
          margin-top: 100px !important;
        }
        &.top-3 {
          margin-top: 100px !important;
        } */
        .text {
          font-size: 16px;
        }
        .item-vote {
          .scores {
            font-size: 16px;
          }
          .number {
            font-size: 22px;
          }
        }
        .item-star {
          .avatar {
            font-size: 16px;
          }
          .number {
            font-size: 22px;
          }
        }
        .btn {
          margin: 15px auto;
        }

        .image {
          .avatar {
            min-height: 100%;
          }
        }

        .stars {
          margin-top: 15px;
          p {
            font-size: 15px;
          }
        }
      }
    }
  }
  .item-rating {
    transform: translateY(-10px);
    img {
      width: 100%;
    }
  }
  @media only screen and (max-width: 991px) {
    &#rank-1 {
      margin-top: -100px;
    }
  }
  @media only screen and (max-width: 767px) {
    &#rank-1 {
      margin-top: 0px;
    }
  }
`;
